module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "cancel-subscription",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: ['modal-dialog',
      {
        'technical-reason-dialog': _vm.currentReason.id === 0 && _vm.show.solution
      },
      {
        'save-money-dialog': _vm.currentReason.id === 1 && _vm.show.solution
      },
      {
        'not-need-dialog': _vm.currentReason.id === 2 && _vm.show.solution
      },
      {
        'switch-package-dialog': _vm.currentReason.id === 3 && _vm.show.solution
      },
      {
        'other-reason-dialog': _vm.currentReason.id === 4 && _vm.show.solution
      },
      {
        'reason-list-dialog': _vm.show.list
      },
      {
        'sure-dialog': _vm.show.sureModal
      }
    ],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])]), _vm._v(" "), (_vm.show.solution) ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.currentReason.reason))]) : _vm._e(), _vm._v(" "), (_vm.show.sureModal) ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('proceedTitle')))]) : _vm._e()]), _vm._v(" "), (_vm.show.list) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "sorry-message"
  }, [_vm._v(_vm._s(_vm.$t('sorryMessage')))]), _vm._v(" "), _vm._l((_vm.$t('cancelReasonList')), function(reason, index) {
    return _c('p', {
      staticClass: "reason-list",
      on: {
        "click": function($event) {
          return _vm.chooseReason(reason)
        }
      }
    }, [_c('span', {
      class: [_vm.currentReason.id === index ? 'chosen-icon' : 'circle-span']
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentReason.id === index),
        expression: "currentReason.id === index"
      }],
      attrs: {
        "src": "/static/img/affiliate/agree_policy_2x.png"
      }
    })]), _vm._v(_vm._s(reason.reason) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "keep-subscription",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('keepSubscription')))]), _vm._v(" "), _c('button', {
    staticClass: "continue-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showSolution
    }
  }, [_c('span', {
    staticClass: "fill-bg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('continueBtn')))])])])] : (_vm.show.solution) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentReason.solution))]), (_vm.currentReason.id === 0) ? _c('span', {
    staticClass: "email"
  }, [_vm._v("iplexservice@gmail.com")]) : _vm._e(), _vm._v(" "), (_vm.currentReason.id === 4) ? _c('p', {
    staticClass: "custom-reason-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customReason),
      expression: "customReason"
    }],
    attrs: {
      "name": "customReason",
      "rows": "3",
      "placeholder": _vm.$t('enterReason')
    },
    domProps: {
      "value": (_vm.customReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customReasonLength) + "/300")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "keep-subscription",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('keepSubscription')))]), _vm._v(" "), _c('button', {
    staticClass: "continue-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showSureModal
    }
  }, [_c('span', {
    staticClass: "fill-bg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('continueBtn')))])])])] : (_vm.show.sureModal) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('cancelSubscriptionNotice')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "keep-subscription",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('keepSubscription')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel-subscription-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSubscription
    }
  }, [_c('span', {
    staticClass: "fill-bg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cancelSubscription')))])])])] : (_vm.show.cancelling) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('spinner-component', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.show.cancelling
    }
  })], 1)] : (_vm.show.cancelSuccess) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('cancelSuccess')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer sure-btn-box"
  }, [_c('button', {
    staticClass: "sure-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))])])] : (_vm.show.cancelFailed) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.cancelError))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer sure-btn-box"
  }, [_c('button', {
    staticClass: "sure-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))])])] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2521e2b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/cancelSubscription/Index.vue
// module id = 1282
// module chunks = 1